import { useAuthStore } from '@/stores/authStore';
import { useGetStudentsSchedulingDetails } from '../api/getStudentsSchedulingDetails';
import { canStudentSchedule } from '../utils/schedulability';

interface UseCanScheduleResult {
  canSchedule: boolean;
  isLoading: boolean;
}

export const useCanSchedule = (): UseCanScheduleResult => {
  const { userData } = useAuthStore();
  const isSchedulingEnabled = !!userData?.center?.features?.scheduling;
  const hasExternalScheduling = !!userData?.center?.externalSchedulingUrl;

  const shouldFetch = isSchedulingEnabled && !hasExternalScheduling;

  const { data, isLoading } = useGetStudentsSchedulingDetails({
    options: { enabled: shouldFetch },
  });

  if (!isSchedulingEnabled) {
    return { canSchedule: false, isLoading: false };
  }

  if (hasExternalScheduling) {
    return { canSchedule: true, isLoading: false };
  }

  if (isLoading || !data) {
    return { canSchedule: false, isLoading: true };
  }

  return {
    canSchedule: data.students.some((student) => canStudentSchedule(student)),
    isLoading: false,
  };
};
